<template lang="pug">
div.routes.schedule
  div.route-schedule
    div.toolbar.toolbar--bordered
      div.line
        h1.title {{selectedMonth.name | firstLetterCapital}}


    div.content
      div.switch
        button(
          @click="prevWeek()"
        ).prev
        button(
          @click="nextWeek()"
        ).next

      div.route-schedule-field
        div.route-schedule-field__line
          div.route-schedule-text
          div(
            v-for="dayInWeek in weekRange"
            :key="dayInWeek"
          ).route-schedule-text {{getOffsetDayByWeek(dayInWeek).dayOfMonth}}


      div(
      v-if="!hasRoutes"
      ).route-schedule-field
        div.route-schedule-field__line
        div.route-schedule-text Нет маршрутов

      div(
        v-else
        v-for="route in routes.data"
        :key="route.id"
      ).route-schedule-field
        div.route-schedule-field__line
          div.route-schedule-text Маршрут {{route.name}}
          route-schedule-block(
          v-for="(dayInWeek, index) in weekRange"
          :route="route"
          :shedules="shedules"
          :dayInfo="getOffsetDayByWeek(dayInWeek).info"
          :day="getOffsetDayByWeek(dayInWeek).info.day || null"
          :month="getOffsetDayByWeek(dayInWeek).info.month || null"
          :week="getOffsetDayByWeek(dayInWeek).info.week || null"
          :year="getOffsetDayByWeek(dayInWeek).info.year || null"
          :dayInWeek="dayInWeek"
          :cars="cars"
          :key="dayInWeek"
          )


</template>

<script>
  import {transport} from '../../api/api-endpoints'
  import scheduleMixin from './mixins/shedule-mixin'
  import RouteScheduleBlock from "./components/route-schedule-block"

  export default {
    name: 'schedule',
    components: {RouteScheduleBlock},
    mixins: [scheduleMixin],
    methods: {
      getRouteDay(weekDay) {
        return this.getOffsetDayByWeek(weekDay)
      },
      getRoutesEndpoint () {
        return transport.routes({
          query: {
            'per-page': -1
          }
        })
      },
      getCarsEndpoint () {
        return transport.park({
          query: {
            'per-page': -1
          }
        })
      },
      getScheduleEndpoint () {
        return transport.routeSchedule()
      }
    }
  }
</script>
